module.exports = __webpack_public_path__ + "assets/home-min.20dcb23e1d96223bec53838d0cb03454.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/Ajuntament/home-min.jpg
 ** module id = 408
 ** module chunks = 0
 **/